/** Generally we should use Playwright's locators (https://playwright.dev/docs/api/class-locator) to
 * get UI elements without the need for data- constants. However some copmonents like <svg>s an be
 * very tricky to reliably locate, so we can use data-test-ids with these constants to make this easier.
 */
const dataTestids = {
  LAYOUT: {
    HEADER: {
      LOGO: 'layout-header-logo',
      MOBILE_SIDEPANEL: 'layout-header-mobile-sidepanel',
      MOBILE_SIDEPANEL_BUTTON: 'layout-header-mobile-sidepanel-button',
      ABOUT_US: 'layout-header-about-us',
      WHAT_WE_OFFER: 'layout-header-what-we-offer',
      IMPACT: 'layout-header-impact',
      RESOURCEDS: 'layout-header-resources',
    },
    FOOTER: {
      LOGO: 'layout-footer-logo',
      YOUTUBE: 'layout-footer-youtube',
      LINKED_IN: 'layout-footer-linked-in',
    },
    PROFILE_DROPDOWN: 'layout-profile-dropdown',
    ORG_DROPDOWN: 'layout-org-dropdown',
  },
  DASHBOARD: {
    NAVBAR: {
      LOGO: 'dashboard-navbar-logo',
      TEXT: 'dashboard-navbar-text',
    },
    LEFTNAV: 'left-nav-container',
    SEARCH_STATUS: {
      POSTPONED_DATEPICKER: 'dashboard-search-postponed-until',
    },
  },
  MY_PROJECTS: {
    PROJECT_CARD: {
      CONTAINER: 'my-projects-project-card-container',
    },
  },
} as const;

export default dataTestids;
